const { default: axios } = require('axios');
const { buildApiURL, isBrowser } = require('./utils');

const RECOMBEE_BASE_URL = process.env.GATSBY_RECOMBEE_CLIENT_BASE_URL;
const RECOMBEE_DATABASE = process.env.GATSBY_RECOMBEE_DATABASE;
const RECOMBEE_PUBLIC_TOKEN = process.env.GATSBY_RECOMBEE_PUBLIC_TOKEN;

let userId = '';

if (isBrowser()) {
    userId = window.rudderanalytics.getAnonymousId();
}

/**
 * Send a request to recombee to set view count
 * @constructor
 * @param {string | number} articleId - The id of article
 */
const sendDetailView = async (articleId) => {
    const apiURL = buildApiURL(`/${RECOMBEE_DATABASE}/detailviews/`, RECOMBEE_BASE_URL, RECOMBEE_PUBLIC_TOKEN, true);
    await axios.post(apiURL, {
        userId,
        itemId: articleId,
        cascadeCreate: true,
    });
};

/**
 * Send a request to recombee to get the most popular articles
 */
const getPopularRecommend = async (locale) => {
    const apiURL = buildApiURL(`/${RECOMBEE_DATABASE}/recomms/users/${userId}/items/`, RECOMBEE_BASE_URL, RECOMBEE_PUBLIC_TOKEN, true);
    try {
        const { data } = await axios.post(apiURL, {
            count: 10,
            scenario: `blog-app---popular-posts${locale === 'es-US' ? '-es' : ''}`,
            cascadeCreate: true,
        });
        return data;
    } catch {
        return {
            recomms: [],
        };
    }
};

module.exports = { getPopularRecommend, sendDetailView };
